export const TYPE_COUNT = 'count';
export const TYPE_TIME = 'time';
export const TYPE_STAR = 'star';
export const TYPE_PERCENTAGE = 'percentage';

export const TYPE_TIME_DECIMAL_PLACES = 2;
export const TYPE_STAR_DECIMAL_PLACES = 2;
export const TYPE_PERCENTAGE_DECIMAL_PLACES = 1;

export const VALUE_TYPES = {
	months: 'months',
	days: 'days',
	hours: 'hours',
	minutes: 'minutes',
	percentage: 'percentage',
} as const;

export const PERCENTAGE_TYPE = 'sd.report.axis.type.percentage';
